import {
  COORDINATE_TYPE_ZOOM,
  CSMapZoomConfiguration
} from 'components/discovery/store-locator/typing/internal.js'
import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { createSignal } from '@cloudsuite/mosaic-shared/scripts/signals.js'

export const STORE_MAP_CONFIGURATION_STORE = Symbol('STORE_MAP_CONFIGURATION_STORE')

@registerDependency(REAL, STORE_MAP_CONFIGURATION_STORE)
@registerDependency(FAKE, STORE_MAP_CONFIGURATION_STORE)
export class StoreMapConfigurationStore {

  mapZoomConfig: () => CSMapZoomConfiguration
  private setMapZoomConfig: (config: CSMapZoomConfiguration) => void

  mapsApiKey: string = ''

  marker: string | null = null

  constructor() {
    [this.mapZoomConfig, this.setMapZoomConfig] = createSignal<CSMapZoomConfiguration>(COORDINATE_TYPE_ZOOM)
  }

  setMapsApiKey(mapsApiKey: string) {
    this.mapsApiKey = mapsApiKey
  }

  setZoomConfig(config: CSMapZoomConfiguration) {
    this.setMapZoomConfig({
      ...this.mapZoomConfig(),
      ...config
    })
  }

  setMarker(marker: string) {
    this.marker = marker
  }
}
